import { createContext, useContext, useReducer, useEffect } from "react";
import { loadCart, saveCart } from "../utils/localStorage";

const CartContext = createContext(null);

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD_ITEM": {
      const existing = state.find(item => item.productId === action.product.id);
      if (existing) {
        return state.map(item =>
          item.productId === action.product.id
            ? { ...item, quantity: item.quantity + (action.quantity || 1) }
            : item
        );
      }
      return [
        ...state,
        {
          productId: action.product.id,
          name: action.product.name,
          price: action.product.price,
          salePrice: action.product.salePrice,
          image: action.product.images[0],
          quantity: action.quantity || 1,
        },
      ];
    }
    case "UPDATE_QUANTITY": {
      if (action.quantity <= 0) {
        return state.filter(item => item.productId !== action.productId);
      }
      return state.map(item =>
        item.productId === action.productId
          ? { ...item, quantity: action.quantity }
          : item
      );
    }
    case "REMOVE_ITEM":
      return state.filter(item => item.productId !== action.productId);
    case "CLEAR":
      return [];
    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const [items, dispatch] = useReducer(cartReducer, [], loadCart);

  useEffect(() => {
    saveCart(items);
  }, [items]);

  return (
    <CartContext.Provider value={{ items, dispatch }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCartContext() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCartContext must be inside CartProvider");
  return ctx;
}
